var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Flex',{staticClass:"page-404",attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"t-center"},[_c('div',{staticClass:"typo--1"},[_vm._v(" 404 ")]),_c('div',[_vm._v("We're sorry, this page doesn't exists.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }